import {
  Component,
  Event,
  State,
  type EventEmitter,
  Prop,
  Listen,
} from '@stencil/core';
import type { SearchResultClickEvent } from '../../../SearchResultClickEvent';
import type { SearchResultsPresentationEvent } from '../../../SearchResultsPresentationEvent';
import type { SearchApi } from '../../../../../../api/SearchApi';
import { appendSectionToTabName } from '../utils/utils';
import { getAnalyticsCat, getSiteSearchCategory } from '../../../../../analytics-reporting/util';

@Component({
  tag: 'dashboard-analytics',
})
export class DashboardAnalytics {
  private currentPage = 1;
  private reflectedState;
  private section: string;

  @Prop() readonly country: string;
  @Prop() readonly language: string;
  @Prop() readonly tabName: string;
  @Prop() readonly appName: string;
  @Prop() readonly isVisible: boolean = true;
  @Prop() readonly apigeeAuth: string;
  @Prop() readonly apigeeTokenUrl: string;
  @Prop() readonly apiEndpointProp: URL;
  @Prop() readonly analyticsTabName: string;
  @Prop() readonly query: string;
  @Prop() readonly searcher?: string;
  @Prop() readonly reflectedTabs: Object;
  @State() queryResult: SearchApi | any;//eslint-disable-line @typescript-eslint/no-explicit-any

  @Event({
    eventName: 'search:SearchResultClickEvent',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    searchResultClickEmitter: EventEmitter<SearchResultClickEvent>;

  @Event({
    eventName: 'search:SearchResultsPresentationEvent',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    SearchResultsPresentationEventEmitter: EventEmitter<SearchResultsPresentationEvent>;

  @Listen('search:ResultCardClick', { target: 'document' })
  handleResultCardClick(e) {
      e.stopPropagation();
      const {
        searchResultPosition,
        rightButton,
        openUrl,
        title,
        id,
        category,
        resutCardType,
        clickedArea,
        clickType,
        commStatus,
        product,
        section,
        circularNature
      } = e.detail;

      const site_search_category = appendSectionToTabName(
        getSiteSearchCategory(this.analyticsTabName, this.appName),
        section
      );

      this.searchResultClickEmitter.emit({
        event: 'searchResultClick',
        appName: this.appName,
        searchPagePosition: this.currentPage,
        searchResultPosition,
        site_search_category,
        siteSearchKeyword: this.query,
        is_filter_use: false,
        rightButton,
        openUrl,
        title,
        id,
        category,
        resutCardType,
        clickedArea,
        tabName: site_search_category,
        clickType,
        commStatus,
        product,
        country: this.country,
        language: this.language,
        endpoint: this.apiEndpointProp,
        apigeeTokenUrl: this.apigeeTokenUrl,
        apigeeAuth: this.apigeeAuth,
        searcher: this.searcher,
        isDashboard: true,
        circularNature
      });
  }

  @Listen('search:SearchResultsStateEvent', { target: 'document' })
  @Listen('search:allTabsFinished',{ target: 'document' })
  sendSearchResultPresentationEvent(e) {
      if (e.type === 'search:SearchResultsStateEvent' && e.detail.reflectedState) this.reflectedState = e.detail.reflectedState;
      if (e.type === 'search:allTabsFinished' && this.reflectedState) {
        if (this.isVisible) {
          const hits: number = this.getNumberOfResults();

          if (this.query !== undefined && hits !== undefined) {
            this.SearchResultsPresentationEventEmitter.emit({
              event: 'search',
              appName: this.appName,
              kw55: this.reflectedState.term,
              suggestion: this.reflectedState.suggestion,
              guidedSearch: false,
              sort: '',
              refinedSearch: false,
              siteSearchResults: hits,
              tabName: getSiteSearchCategory(this.analyticsTabName, this.appName),
            });
          }
        }
      }
  }

  private getNumberOfResults = () => Object?.keys(this.reflectedTabs)
    .filter(key => !key.includes('/all') && this.reflectedTabs[key]?.count)
    .reduce((totalCount, key) => totalCount + this.reflectedTabs[key].count, 0);
}
